import { render } from "./selectGroup.vue?vue&type=template&id=51f87e79&scoped=true&ts=true"
import script from "./selectGroup.vue?vue&type=script&lang=ts"
export * from "./selectGroup.vue?vue&type=script&lang=ts"

import "./selectGroup.vue?vue&type=style&index=0&id=51f87e79&lang=less"
import "./selectGroup.vue?vue&type=style&index=1&id=51f87e79&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f87e79"]])

export default __exports__